import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export async function getMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function exchangeSession(sessionId) {
  const { data } = await api.post("/auth/session", null, {
    headers: { "X-Session-ID": sessionId },
  });
  return data;
}

export async function logout() {
  const { data } = await api.post("/auth/logout");
  return data;
}

export async function listProjects() {
  const { data } = await api.get("/projects");
  return data;
}

export async function getProject(id) {
  const { data } = await api.get(`/projects/${id}`);
  return data;
}

export async function createProject(payload) {
  const { data } = await api.post("/projects", payload);
  return data;
}

export async function updateProject(id, payload) {
  const { data } = await api.put(`/projects/${id}`, payload);
  return data;
}

export async function deleteProject(id) {
  const { data } = await api.delete(`/projects/${id}`);
  return data;
}

export async function calculate(inputs) {
  const { data } = await api.post("/calculate", inputs);
  return data;
}
